<template>
  <div class="py-4 bg-secondary" style="padding-bottom: 0px !important;">
    <div class="profile-page">
      <!-- shape Hero -->
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{$t('submenu.pro_xabar_t')}}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <button class="button_sorov add-to-cart"  @click="questionDialog = true"><i class="el-icon-question"></i>
        {{ $i18n.locale === 'uz-CYR' ? 'Сўровнома' : $i18n.locale === 'ru-RU' ? 'Опрос' : "So'rovnoma" }}
      </button>
<!--      <button class="button_sorov add-to-cart"  @click="questionDialog = true"><i class="el-icon-question"></i></button>-->
      <section class="section py-3">
        <div class="container">
          <!--                    <card shadow class="card-profile mt&#45;&#45;100 card_radius_no" no-body style="z-index: 10;">-->
          <card shadow class="card-profile mt--100 card_radius_no" no-body>
            <div class="px-4">
              <div class="text-center mt-2">
                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                    class="news_title">{{$t('contact.murojaat_title')}} </span></div>
              </div>
              <div class="mt-3 py-3 border-top text-center">
                <div class="row justify-content-center">
                  <div class="col-lg-12">
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat1')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat2')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat3')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat4')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat5')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat6')"></p>
                    <p style="text-align: justify;" v-html="$t('murojaat_title.murojaat7')"></p>
                    <strong style="float: right; text-align: right;" v-html="$t('murojaat_title.murojaat8')"></strong>
                  </div>
                </div>
<!--                <el-row :gutter="15">-->
<!--                  <el-col :sm="24" :md="12" :lg="6" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.fio')}}</div>-->
<!--                    <el-input-->
<!--                        v-model="sendMurojaatFrom.fullName"-->
<!--                        clearable>-->
<!--                    </el-input>-->
<!--                  </el-col>-->
<!--                  <el-col :sm="24" :md="12" :lg="4" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.telefon')}}</div>-->
<!--                    <el-input-->
<!--                        placeholder="+998901234567"-->
<!--                        v-model="sendMurojaatFrom.phone"-->
<!--                        clearable>-->
<!--                    </el-input>-->
<!--                  </el-col>-->
<!--                  <el-col :sm="24" :md="12" :lg="4" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.viloyat')}}</div>-->
<!--                    <el-select v-model="sendMurojaatFrom.regionId" @change="changeViloyat" placeholder="Вилоятни танланг" class="w-100 mb-2"-->
<!--                               clearable>-->
<!--                      <el-option-->
<!--                          v-for="item of regionList"-->
<!--                          :key="item.id"-->
<!--                          :label="item.nameCrl"-->
<!--                          :value="item.id">-->
<!--                      </el-option>-->
<!--                    </el-select>-->


<!--                  </el-col>-->
<!--                  <el-col :sm="24" :md="12" :lg="4" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.shahar')}}</div>-->
<!--                    <el-select v-model="sendMurojaatFrom.districtId"  placeholder="Туман танланг" class="w-100" clearable>-->
<!--                      <el-option-->
<!--                          v-for="item of districtList"-->
<!--                          :key="item.id"-->
<!--                          :label="item.nameCrl"-->
<!--                          :value="item.id">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
<!--                  </el-col>-->
<!--                  <el-col :sm="24" :md="24" :lg="6" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.manzil')}}</div>-->
<!--                    <el-input-->
<!--                        v-model="sendMurojaatFrom.address"-->
<!--                        clearable>-->
<!--                    </el-input>-->
<!--                  </el-col>-->
<!--                  <el-col :span="24" style="text-align: left;">-->
<!--                    <div class="sub-title">{{$t('contact.izoh')}}</div>-->
<!--                    <el-input-->
<!--                        type="textarea"-->
<!--                        :autosize="{ minRows: 5, maxRows: 10}"-->
<!--                        v-model="sendMurojaatFrom.description">-->
<!--                    </el-input>-->
<!--                  </el-col>-->
<!--                  <el-col :span="24" style="margin-top: 20px;">-->
<!--                    <el-upload-->
<!--                        class="upload-demo"-->
<!--                        drag-->
<!--                        name="main-document"-->
<!--                        action="https://www.prokuratura.uz/api/file-storages"-->
<!--                        :file-list="files"-->
<!--                        :on-remove="handleRemove"-->
<!--                        :on-success="mainFileUploadSuccess">-->
<!--                      <i class="el-icon-upload"></i>-->
<!--                      <div class="el-upload__text"><em>{{$t('contact.fayl')}}</em></div>-->
<!--                      <div class="el-upload__tip" slot="tip">{{$t('contact.fayl_text')}}</div>&ndash;&gt;-->
<!--                    </el-upload>-->

<!--                  </el-col>-->
<!--                </el-row>-->
<!--                <el-button type="primary" v-on:click="sendMessage" size="medium" style="margin-top: 20px;">{{$t('contact.yuborish')}}</el-button>-->
              </div>
            </div>
          </card>
        </div>
      </section>
      <section class="section py-1 mb-3">
        <div class="container">
          <card shadow class="card_radius_no" no-body>
            <div class="px-4">
              <div class="text-center mt-2">
                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                    class="news_title">{{$t('korrupsiya_xabar.xabar_title')}}</span></div>
              </div>
              <div class="mt-3 py-3 border-top text-center">
                <div class="row justify-content-center">
                  <div class="col-lg-12">
                    <div>
                      <el-collapse v-model="activePro" accordion>
                        <!--                                            <el-collapse-item :title="$t('prokururor_tel.prokuror_pro')" name="1" class="text-center">-->
                        <el-collapse-item title="" name="1" class="text-center">
                          <!--                                                <h4 class="display-3 text-titlecolor title_text mb-30" style="font-weight: 600 !important;">{{$t('prokururor_tel.prokuror_pro')}} </h4>-->
                          <template>
                            <el-table
                                :data="tableDataPro"
                                border
                                style="width: 100%">
                              <el-table-column
                                  prop="numb"
                                  label="№"
                                  align="center"
                                  width="50">
                              </el-table-column>
                              <el-table-column
                                  prop="organ"
                                  :label="$t('korrupsiya_xabar.xudud_nomi')">
                                <template slot-scope="{ row }">{{ $t(row.organ) }}</template>
                              </el-table-column>
                              <el-table-column
                                  prop="phone"
                                  align="center"
                                  :label="$t('korrupsiya_xabar.telefon_raqam')"
                                  width="300">
                              </el-table-column>
                            </el-table>
                          </template>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
      <el-dialog title="Maxfiy kodni kiriting!" :visible.sync="dialogKod"
                 width="20%">
        <div style="text-align: left;">
          <div class="sub-title">Telefoninggizga kelgan maxfiy kodni kiriting!</div>
          <el-input
              v-model="code"
              clearable>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogKod = false">Bekor qilish</el-button>
                <el-button size="mini" type="primary" @click="activeCode">Tasdiqlash</el-button>
              </span>
      </el-dialog>

      <el-dialog
          title="Сўровнома"
          :visible.sync="questionDialog"
          width="50%"
          center>
        <div style="display: grid;" v-for="(test, index) in tests" v-if="index === nextTest">
          <strong style="margin-bottom: 10px;"><b>{{ index + 1 }}.</b> {{ test.question }}</strong>
            <el-radio class="answer_new" v-model="radio" :label="answer" v-for="(answer, index) in test.answers">{{ answer }},</el-radio>
        </div>
        <div style="display: grid;" v-if="nextTest === tests.length">
          <h3>Сўровнома қабул қилинди. Иштирокингиз учун раҳмат.</h3>
        </div>
        <span v-if="nextTest !== tests.length" slot="footer" class="dialog-footer">
          <el-button @click="questionDialogClose">Бекор қилиш</el-button>
          <el-button type="primary" @click="testShow">{{ buttonNext }}</el-button>
        </span>
      </el-dialog>

    </div>
  </div>

</template>

<script>
import axios from 'axios';
export default {
  name: "home",
  data() {
    return {
      tests: [
          {
            question: 'Сизнингча коррупциявий ҳуқуқбузарликларга олиб келувчи сабаб ва шарт-шароитлар нималардан иборат?',
            answers: [
                'Хизмат мавқеидан фойдаланиб тезда бойлик орттиришга интилиш',
                'Бюрократик тўсиқларнинг ҳаддан зиёдлиги',
                'Давлат хизматларининг тўлиқ рақамлаштирилмаганлиги',
                'Давлат хизматчиларига хизмат вазифаларидан ташқари бўлган қўшимча вазифаларнинг юклатилиши',
                'Давлат хизматчиларининг моддий таъминотининг етарли эмаслиги',
                'Аҳоли ҳуқуқий маданиятининг пастлиги',
                'Жавоб беришга қийналаман'
            ]
          },
          {
            question: 'Коррупцияга қарши курашишда қандай чоралар самаралироқ деб ўйлайсиз? ',
            answers: [
                'Коррупцияга оид ҳуқуқбузарликларни содир этганлик учун жавобгарликнинг муқаррарлигини таъминлаш',
                'Жиноий жазо чораларини кучайтириш',
                'Мансабдор шахсларнинг ваколатларини қонуний асосда тийиб туриш',
                'Жамоатчилик назоратини кучайтириш',
                'Давлат хизматчиларининг моддий таъминотини яхшилаш',
                'ОАВларида коррупцияга қарши курашишни ёритиш, коррупционер шахсларни фош қилиш',
            ]
          },
          {
            question: 'Сиз коррупция ҳолатига дуч келсангиз, бу ҳақда хуқуқни муҳофаза қилувчи органларига мурожаат қиласизми? ',
            answers: [
                'Ҳа, албатта',
                'Мурожаат қилиш эҳтимолим катта',
                'Вазиятга қараб',
                'Мурожаат этмасдим, бу билан махсус ходимлар шуғулланиши керак',
                'Жавоб беришга қийналаман',
            ]
          },
          {
            question: 'Коррупциявий ҳолатлар тўғрисида хабар берганлик учун рағбатлантириш мавжудлиги ҳақида хабарингиз борми?',
            answers: [
                'Ҳа',
                'Йўқ',
            ]
          },
          {
            question: 'Хуқуқни муҳофаза қилувчи органларининг коррупцияга қарши курашиш борасидаги фаолияти ҳақида қайси манбадан хабардор бўласиз?',
            answers: [
                'Оммавий ахборот воситалари орқали',
                'Хуқуқни муҳофаза қилувчи органларнинг расмий сайти орқали',
                'Бошқа ижтимоий тармоқлардаги саҳифалар орқали',
                'Хуқуқни муҳофаза қилувчи ходимларининг жойлардаги тарғибот тадбирлари орқали',
                'Ҳеч қаерда ушбу ҳақида маълумот эълон қилинмайди ',
            ]
          }
      ],
      nextTest: 0,
      activePro: null,
      input: '',
      id:null,
      textarea2: '',
      regionList: [],
      districtList: [],
      code:null,
      files:[],
      buttonNext: 'Кейингиси',
      sendMurojaatFrom:{
          fullName:'',
          regionId: null,
          districtId: null,
          address:'',
          phone:'',
          description:'',
          paths: []
      },
      dialogKod:false,
      questionDialog: false,
      radio: '',
      value: '',
      answers: '',
      tableDataPro: [{
        numb: '1',
        organ: 'ishonch_tel.ishonch_table_row1',
        phone: '(71) 202-08-28'
      }, {
        numb: '2',
        organ: 'ishonch_tel.ishonch_table_row7',
        phone: '(61) 224-99-09'
      }, {
        numb: '3',
        organ: 'ishonch_tel.ishonch_table_row3',
        phone: '(74) 237-99-08'
      }, {
        numb: '4',
        organ: 'ishonch_tel.ishonch_table_row4',
        phone: '(65) 221-66-48'
      }, {
        numb: '5',
        organ: 'ishonch_tel.ishonch_table_row5',
        phone: '(72) 221-55-19'
      }, {
        numb: '6',
        organ: 'ishonch_tel.ishonch_table_row6',
        phone: '(75) 220-07-10'
      }, {
        numb: '7',
        organ: 'ishonch_tel.ishonch_table_row8',
        phone: '(79) 222-07-12'
      }, {
        numb: '8',
        organ: 'ishonch_tel.ishonch_table_row9',
        phone: '(69) 211-77-08'
      }, {
        numb: '9',
        organ: 'ishonch_tel.ishonch_table_row10',
        phone: '(66) 230-44-09'
      }, {
        numb: '10',
        organ: 'ishonch_tel.ishonch_table_row11',
        phone: '(67) 227-44-08'
      }, {
        numb: '11',
        organ: 'ishonch_tel.ishonch_table_row12',
        phone: '(76) 225-66-08'
      }, {
        numb: '12',
        organ: 'ishonch_tel.ishonch_table_row14',
        phone: '(70) 201-07-12'
      }, {
        numb: '13',
        organ: 'ishonch_tel.ishonch_table_row13',
        phone: '(71) 277-64-71'
      }, {
        numb: '14',
        organ: 'ishonch_tel.ishonch_table_row15',
        phone: '(73) 229-07-10'
      }, {
        numb: '15',
        organ: 'ishonch_tel.ishonch_table_row16',
        phone: '(62) 227-77-09'
      }, {
        numb: '16',
        organ: 'ishonch_tel.ishonch_table_row31',
        phone: '(71) 202-07-85'
      }, {
        numb: '17',
        organ: 'ishonch_tel.ishonch_table_row32',
        phone: '(71) 202-07-18'
      }, {
        numb: '18',
        organ: 'ishonch_tel.ishonch_table_row2',
        phone: '(71) 202-86-67'
      }, {
        numb: '18',
        organ: 'ishonch_tel.ishonch_table_row33',
        phone: '(71) 207-11-35'
      }]
    }

  },
  methods:{
    questionDialogClose() {
      this.questionDialog = false
      this.answers = ''
    },
    testShow() {
      if (this.radio === '') {
        this.$message({
          message: 'Илтимос жавобни танланг!',
          type: 'warning'
        });
      } else {
        if (this.nextTest < this.tests.length) {
          this.nextTest++;
          axios
              // .post(`https://www.prokuratura.uz/api/post-survey`, {
                  // .post(`https://localhost:8081/api/post-survey`, {
              .post(` https://www.prokuratura.uz/api/post-survey`, {
                question: this.tests[this.nextTest - 1].question,
                answer: this.radio
              })
              .then(res => {
                this.radio = ''
              })
        }
      }
      if (this.nextTest === this.tests.length) {
        setTimeout(() => {
          this.questionDialog = false
        }, 1500)
        setTimeout(() => {
          this.nextTest = 0
        }, 2000)
      }
    },
    activeCode(){
      axios
          .get(`https://www.prokuratura.uz/api/confirm-murojaat/${this.id}/${this.code}`)
          .then(({ data }) => {
         this.dialogKod=false;
          })
          .catch(error => {
            this.$message.error(`Хатолик юз берди:`);
          })
    },
    handleRemove(file) {
        this.sendMurojaatFrom.paths = this.sendMurojaatFrom.paths.filter(item => {
            if (item !== file.response.imageUrl) {
                return item;
            }
        });
    },
    mainFileUploadSuccess(data) {
        this.sendMurojaatFrom.paths.push(data.imageUrl);
    },
    sendMessage(){
        axios
            .post('https://www.prokuratura.uz/api/save-murojaat', this.sendMurojaatFrom)
            .then(({ data }) => {
              this.$message({
                type: 'success',
                message: 'Янгилик кўшилди'
              });
              this.id=data.id;
              this.dialogKod=true;
            })
            .catch(error => {
              this.$message.error(`Хатолик юз берди:`);
            })
    },
    loadViloyat() {
      axios
          .get(`https://www.prokuratura.uz/api/all-regions`)
          .then(response => {
            if (response.data) {
              this.regionList = response.data;
              if (response.data && response.data.length === 1){
                this.sendMurojaatFrom.regionId = response.data[0].id
                this.changeViloyat(this.sendMurojaatFrom.regionId)
              }
            }
          })
          .catch(e => {
            this.errors.push(e);
          });
    },
    loadTuman(viloyatId) {
      if (viloyatId) {
        axios
            .get(`https://www.prokuratura.uz/api/districts-by-region/${viloyatId}`)
            .then(response => {
              if (response.data) {
                this.districtList = response.data;
                if (response.data && response.data.length === 1){
                  this.sendMurojaatFrom.district = response.data[0].id
                  this.changeTuman(this.sendMurojaatFrom.district)
                }
              }
            })
            .catch(e => {
              this.errors.push(e);
            });
      }
    },
    changeViloyat(id) {
      this.districtList = [];
      this.sendMurojaatFrom.districtId = null;
      this.loadTuman(id);
    },
    onSuccessUploadNewExtraFile(res, file) {
      this.sendMurojaatFrom.filePath = res.name;
      this.isFileUploading = false;
    },
    beforeUploadNewExtraFile() {
      this.isFileUploading = true;
    },
    onRemoveMainFile() {
      this.sendMurojaatFrom.filePath = null;
    },

  },
  created() {
    this.loadViloyat();

  }
};
</script>
<style scoped>
::v-deep .el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 360px;
  height: 100px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload-dragger .el-icon-upload {
  font-size: 65px;
  color: #C0C4CC;
  margin: 13px 0 16px;
  line-height: 40px;
}

.answer_new {
  display: block;
  word-break: break-word;
  white-space: normal;
}

.button_sorov {
  background-color: #394869;
  border: none;
  margin-left: -155px;
  cursor: pointer;
  position: absolute;
  transition: background-color 0.5s linear, color 0.5s linear;
}
.button_sorov:hover {
  background-color: #394869;
}
.button_sorov:focus {
  outline: none;
}

.add-to-cart {
  -webkit-animation: shadowFloat 1.2s linear alternate infinite;
  animation: shadowFloat 1.2s linear alternate infinite;
  border-radius: 50px;
  color: #fff;
  z-index: 100;
  /*font-size: 30px;*/
  /*padding: 0px 7px;*/
  font-size: 16px;
  padding: 4px 12px;
  text-transform: uppercase;
  text-shadow: 0 1px 1px #394869;
}

@-webkit-keyframes shadowFloat {
  0% {
    box-shadow: 0 20px 40px #c7c7c7;
    transform: translateY(-3px);
  }
  100% {
    box-shadow: 0 10px 10px #bababa;
    transform: translateY(3px);
  }
}

@keyframes shadowFloat {
  0% {
    box-shadow: 0 20px 40px #c7c7c7;
    transform: translateY(-3px);
  }
  100% {
    box-shadow: 0 10px 10px #bababa;
    transform: translateY(3px);
  }
}
</style>
